import { Component, Input, OnInit } from '@angular/core';
import { NavigationItem, NavigationLink } from '../../interfaces/navigation-item.interface';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';
import { trackByRoute } from '../../utils/track-by';

@Component({
  selector: 'vex-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss']
})
export class NavigationItemComponent implements OnInit {
  @Input() item: NavigationItem;

  isActive$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => (item: NavigationItem) => this.hasActiveChilds(item))
  );

  isLink = this.navigationService.isLink;
  isDropdown = this.navigationService.isDropdown;
  isSubheading = this.navigationService.isSubheading;
  trackByRoute = trackByRoute;

  constructor(private navigationService: NavigationService, private router: Router) {}

  ngOnInit() {}

  hasActiveChilds(parent: NavigationItem): boolean {
    let isExact = true;
    if(this.router?.url?.includes('?')){
      isExact = false;
    }
    if (this.isLink(parent)) {
      if(parent.route?.includes("/dashboard")) {
        return this.router.url.startsWith(parent.route as string);
      }
      return this.router.isActive(parent.route as string, isExact);
    }

    if (this.isDropdown(parent) || this.isSubheading(parent)) {
      return parent.children.some((child) => {
        if (this.isDropdown(child)) {
          return this.hasActiveChilds(child);
        }

        if (this.isLink(child) && !this.isFunction(child.route)) { 
          return this.router.isActive(child.route as string, isExact);
        }
        return false;
      });
    }

    return false;
  }

  isActiveNav(item) {
    if(this.router.url.includes("platform-settings/organization-setting") && item.label == 'System') {
      return true;
    }
    if(this.router.url.includes("application-settings/add-role") && item.label == 'System') {
      return true;
    }
    return false;
  }

  isFunction(prop: NavigationLink['route']) {
    return prop instanceof Function;
  }
  toUrl(item) {
    const route = typeof item === 'string' ? item : item?.route;
    if (typeof route !== 'string') {
      return '/';
    }
    return route.split('?')[0] || '/';
  }

  toQueryParams(item) {
    const route = typeof item === 'string' ? item : item?.route;
    if (typeof route !== 'string') {
      return {};
    }
    const queryPart = route.split('?')[1] || '';
    const sp = new URLSearchParams(queryPart);
    const o: Record<string, string> = {};
    sp.forEach((v, k) => {
      o[k] = v;
    });
    return o;
  }
}
